export default __webpack_public_path__ + "static/media/brightReloadIcon.98246aa3.svg";